import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Customers = Loadable(lazy(() => import('./Customers')));
const CreateCustomer = Loadable(lazy(() => import('./CRUD/CreateCustomer')));
const UpdateCustomer = Loadable(lazy(() => import('./CRUD/UpdateCustomer')));
const DeleteCustomer = Loadable(lazy(() => import('./CRUD/DeleteCustomer')));
const CustomerTips = Loadable(lazy(() => import('./CRUD/customerTips')));
const CustomerDetails = Loadable(lazy(() => import('./CRUD/customerDetails')));

const customerRoutes = [
  { path: '/dashboard/customers', element: <Customers />, auth: authRoles.admin },
  {
    path: '/dashboard/customers/create',
    element: <CreateCustomer />,
    auth: authRoles.admin,
  },
  {
    path: '/dashboard/customers/:id/update',
    element: <UpdateCustomer />,
    auth: authRoles.admin,
  },
  {
    path: '/dashboard/customers/:id/delete',
    element: <DeleteCustomer />,
    auth: authRoles.admin,
  },
  {
    path: '/dashboard/customers/:id/tips',
    element: <CustomerTips />,
    auth: authRoles.admin,
  },
  {
    path: '/dashboard/customers/:id/details',
    element: <CustomerDetails />,
    auth: authRoles.admin,
  },
];

export default customerRoutes;
